export enum TopicEnum {
  GENERAL_DATA,
  COMPLAINT,
  RECOURSE_CLAIM,
  NEGOTIATION,
}
